import Cookies from 'js-cookie';
import {FTUE_COOKIE_NAME, FTUE_STATE} from '@/utils/constant';
import {getUserId} from '@/services/internal/user/getUserId';

type FtueState = (typeof FTUE_STATE)[keyof typeof FTUE_STATE];

const getFtueCookieName = (userId: string): string => `${FTUE_COOKIE_NAME}_${userId}`;

const clearOldFtueCookies = () => {
  const allCookies = Cookies.get();
  Object.keys(allCookies).forEach((cookieName) => {
    if (cookieName.startsWith(FTUE_COOKIE_NAME)) {
      Cookies.remove(cookieName, {path: '/'});
    }
  });
};

export const setFtueCookie = (state: FtueState) => {
  const userId = getUserId();
  const cookieName = getFtueCookieName(userId);
  clearOldFtueCookies();
  Cookies.set(cookieName, state, {expires: 3650, path: '/'});
};

export const getFtueCookieClient = (): FtueState | undefined => {
  try {
    const userId = getUserId(false);

    const cookieName = getFtueCookieName(userId);

    return Cookies.get(cookieName) as FtueState | undefined;
  } catch {
    return undefined;
  }
};
